// src/pages/PagoExitoso.js
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PagoExitoso = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Extraer parámetros de la URL
    const paymentId = searchParams.get('payment_id');
    const status = searchParams.get('status');
    const externalRef = searchParams.get('external_reference');

    console.log('✅ Pago exitoso:', { paymentId, status, externalRef });

    // Redirigir a la página de Krums después de 3 segundos
    const timer = setTimeout(() => {
      navigate('/krums?exito=true');
    }, 3000);

    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  return (
    <div className="pago-exitoso-container">
      <div className="pago-exitoso-card">
        <div className="exito-icon">✅</div>
        <h1>¡Pago exitoso!</h1>
        <p>Tus Krums han sido acreditados a tu cuenta.</p>
        <p>Serás redirigido a la tienda en unos segundos...</p>
        <button onClick={() => navigate('/krums')} className="btn-continuar">
          Ir a la tienda ahora
        </button>
      </div>
    </div>
  );
};

export default PagoExitoso;